import { Button, Col, Divider, Flex, Layout, Row, Typography, theme } from 'antd';
import { FC } from 'react';
import { XCircleFill } from 'react-bootstrap-icons';

import { DescriptionBlock } from '@/common/components';

import { SearchConsoleUrlInspection } from '@/modules/DomainsApi';
import { CanonicalLabel, CrawlingUserAgentLabel, IndexingStateLabel, LastCrawlTimeLabel, PageFetchStateLabel, ReferringUrlsLabel, RobotsTxtStateLabel, SitemapLabel, VerdictTag } from './ResultComponents';

interface Props {
  inspectionResultData: SearchConsoleUrlInspection | undefined;
  handleResetResult: () => void;
}

export const SearchConsoleUrlInspectionResultView: FC<Props> = ({
  inspectionResultData,
  handleResetResult,
}) => {
  const { token: { borderRadius, padding, colorBgLayout } } = theme.useToken();
  if (inspectionResultData) {
    const { indexStatusResult, inspectionUrl } = inspectionResultData;

    return (
      <>
        <DescriptionBlock
          column={ 1 }
          items={ [['Протестована URL-адреса', inspectionUrl],] }
        />
        <Layout style={{ height: '100%', borderRadius, padding, paddingTop: 0, overflow: 'auto' }}>
          <Row gutter={ [16, 0] } wrap>
            <Col span={ 24 } style={{ position: 'sticky', top: 0, zIndex: 1001, backgroundColor: colorBgLayout, paddingTop: padding }}>
              <Flex align="center" style={{ height: '100%' }} wrap gap={ 4 }>
                <Typography.Title level={ 4 } style={{ margin: 0, width: '100%' }}>
                  <Flex justify="space-between" align="center">
                    <div>
                      Вирок аналізу:&nbsp;<VerdictTag verdict={ indexStatusResult?.verdict }/>
                    </div>
                    <Button
                      type="text"
                      style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', paddingInline: 6 }}
                    >
                      <XCircleFill size={ 20 } onClick={ handleResetResult }/>
                    </Button>
                  </Flex>
                </Typography.Title>
                <Typography.Text type="secondary">
                  { indexStatusResult?.coverageState }
                </Typography.Text>
              </Flex>
            </Col>

            <Col span={ 24 }>
              <Divider style={{ margin: '8px 0' }}/>
            </Col>

            <Col span={ 24 }>
              <DescriptionBlock
                layout="horizontal"
                items={ [
                  [
                    'Статус індексації URL-адреси',
                    <IndexingStateLabel key="indexingState" indexingState={ indexStatusResult?.indexingState }/>
                  ],
                ] }
              />

              <DescriptionBlock
                title="Виявлення"
                titleSize="small"
                column={ 1 }
                items={ [
                  [
                    'Файли Sitemap',
                    <SitemapLabel key="sitemap" sitemap={ indexStatusResult?.sitemap }/>
                  ],
                  [
                    'Сторінки, що посилаються',
                    <ReferringUrlsLabel key="referringUrls" referringUrls={ indexStatusResult?.referringUrls }/>
                  ],
                  [
                    'Стан robots.txt',
                    <RobotsTxtStateLabel key="robotsTxtState" robotsTxtState={ indexStatusResult?.robotsTxtState }/>
                  ],
                ] }
              />

              <DescriptionBlock
                title="Сканування"
                titleSize="small"
                column={ 1 }
                items={ [
                  [
                    'Останнє сканування',
                    <LastCrawlTimeLabel key="lastCrawlTime" lastCrawlTime={ indexStatusResult?.lastCrawlTime }/>
                  ],
                  [
                    'Проскановано як',
                    <CrawlingUserAgentLabel key="crawledAs" crawledAs={ indexStatusResult?.crawledAs }/>
                  ],
                  [
                    'Завантаження сторінки',
                    <PageFetchStateLabel key="pageFetchState" pageFetchState={ indexStatusResult?.pageFetchState }/>
                  ],
                ] }
              />
              <DescriptionBlock
                title="Індексування"
                titleSize="small"
                column={ 1 }
                items={ [
                  [
                    'Канонічна URL-адреса, яку заявив користувач',
                    <CanonicalLabel key="userCanonical" canonical={ indexStatusResult?.userCanonical }/>
                  ],
                  [
                    'Канонічна URL-адреса, вибрана Google',
                    <CanonicalLabel key="googleCanonical" canonical={ indexStatusResult?.googleCanonical }/>
                  ],
                ] }
              />
            </Col>
          </Row>
        </Layout>
      </>
    );
  };
};
